import PropTypes from 'prop-types';
import {useState} from 'react';
import {View} from 'react-native';

import {Pressable, Text, InputChat} from '~/components/controls';

import sy from '~/styles';

import ChatOutlinedIcon from '~/images/md-icons/chat/materialsymbolsoutlined/24px.svg';
import RemoveIcon from '~/images/md-icons/remove/materialsymbolsoutlined/24px.svg';
import CloseIcon from '~/images/md-icons/close/materialicons/24px.svg';

const InputChatFloating = (props) => {
  const [isPressed, setIsPressed] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const renderSentState = () => (
    <View
      style={[
        sy['bg-primary-dark'],
        sy['rounded-lg'],
        sy['px-4'],
        sy['py-3'],
        sy['flex-row'],
        sy['justify-between'],
        sy['items-center'],
        {
          width: 'calc(100% - 32px)',
          position: 'absolute',
          bottom: 16,
          right: 16,
          shadowOffset: {width: 0, height: 3},
          shadowOpacity: 0.5,
          shadowColor: '#181716',
          shadowRadius: 10,
          elevation: 3,
        },
        props.style,
      ]}>
      <Text style={[sy.smallMedium, sy['text-white']]}>
        {props.is_rob
          ? 'Verzending bericht bij voorstellen'
          : 'Bericht is verzonden'}
      </Text>
      <View style={[sy['flex-row'], sy['items-center'], sy['gap-3']]}>
        <Pressable
          onPress={() => {
            setIsPressed(false);
            setIsSent(false);
            props.onViewSentMessage();
          }}>
          <Text style={[sy.smallMedium, sy['text-secondary-blue']]}>
            Bekijken
          </Text>
        </Pressable>
        <Pressable
          onPress={() => {
            setIsPressed(false);
            setIsSent(false);
          }}>
          <CloseIcon fill="#FFFFFF" width={24} height={24} />
        </Pressable>
      </View>
    </View>
  );

  const renderPressedState = () => (
    <View
      style={[
        sy['bg-tertiary-brown'],
        sy['rounded-lg'],
        sy['p-4'],
        sy['gap-2'],
        {
          width: 'calc(100% - 32px)',
          position: 'absolute',
          bottom: 16,
          right: 16,
          shadowOffset: {width: 0, height: 3},
          shadowOpacity: 0.5,
          shadowColor: '#181716',
          shadowRadius: 10,
          elevation: 3,
        },
        props.style,
      ]}>
      <View style={[sy['flex-row'], sy['justify-between'], sy['items-center']]}>
        <Text style={[sy.medium]}>Nieuw bericht</Text>
        <Pressable onPress={() => setIsPressed(false)}>
          <RemoveIcon fill="#4a4a49" />
        </Pressable>
      </View>
      <InputChat
        style={[sy['p-0']]}
        textStyle={[sy['bg-white']]}
        {...props}
        onSend={async () => {
          await props.onSend();
          setIsSent(true);
        }}
        onAttachment={
          props.onAttachment
            ? async (attachment) => {
                await props.onAttachment(attachment);
                setIsSent(true);
              }
            : null
        }
      />
    </View>
  );

  const renderCollapsedState = () => (
    <Pressable
      style={[
        sy['bg-primary-brown'],
        sy['items-center'],
        sy['justify-center'],
        sy['rounded-2xl'],
        {
          width: 56,
          height: 56,
          position: 'absolute',
          bottom: 16,
          right: 16,
          shadowOffset: {width: 0, height: 3},
          shadowOpacity: 0.5,
          shadowColor: '#181716',
          shadowRadius: 10,
          elevation: 3,
        },
        props.style,
      ]}
      onPress={() => setIsPressed(true)}>
      <ChatOutlinedIcon fill="#ffffff" />
    </Pressable>
  );

  let content = renderCollapsedState();
  if (isSent) {
    content = renderSentState();
  } else if (isPressed) {
    content = renderPressedState();
  }

  return (
    <View style={{position: 'relative', width: '100%', height: 0}}>
      {content}
    </View>
  );
};

InputChatFloating.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  is_rob: PropTypes.bool,
  onViewSentMessage: PropTypes.func,
  onSend: PropTypes.func.isRequired,
  onAttachment: PropTypes.func,
};

export default InputChatFloating;
